import React, { useState } from "react";
import { TfiClose } from 'react-icons/tfi'
import { LiaLinkSolid } from 'react-icons/lia'
import { AiOutlineCaretDown } from 'react-icons/ai'
import { MdDoNotDisturbOn } from 'react-icons/md'
import {BiSolidCheckCircle} from 'react-icons/bi'
import "./style.css"
import CustomBottomSheet from "../CustomBottomSheet";
import FloatingTextInput from "../../../../components/FloatingInput";
import {
    Facebooklink,
    Messanger,
    Instagramlink,
    Link,
    Linkedinlink,
    Pinterestlink,
    Twitterlink,
    Whatsapplink,
    Google,
    Linkoption,
    cart,
    Media

        
 } from '../../../../assets/icons';




    const InteractionsSaved = (props:any) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedLinkOption, setSelectedLinkOption] = useState("");
    const [selectedIcon, setSelectedIcon] = useState<any>();
    const [selectedLinkName, setSelectedLinkName] = useState<any>("");
    const [linkTitle, setLinkTitle] = useState<any>("");
    const [userLink, setUserLink] = useState<any>("");
    const [isShowTitle, setIsShowTitle] = useState(false);
    const tempArray:any=[{
        type:'Link',
        typeImage:Linkoption,
        name:'Google',
        data:'www.google.com'
    },
    {
        type:'Media',
        typeImage:Media,
        name:'Sales Process',
        data:'Your secret weapon to video prospecting'
    }]




    // const setLinkOptions=(selectedLinkOption:any)=>{
    //     switch (selectedLinkOption) {
    //         case 'A':


    //             break;

    //         default:
    //             break;
    //     }
    // }



    const toggleSheet = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div className="relative w-full">
            <div className="h-full w-full flex flex-col " style={{ backgroundColor: '#181818' }}>
                <div className="overflow-y-auto containerbottomSheet" style={{height:'85%'}}>
                    <div className="flex w-full justify-between px-3 h-10 items-center">
                        <div className="h-2.5 w-2.5"></div>
                        <TfiClose color="#DEDEDE" size={20} cursor="pointer" 
                        onClick={()=>{props.handleCloseClick()}}
                        />
                    </div>
                    <div className="flex  mt-2.5">
                        <div>
                            <span className="text-[#DEDEDE] text-[26px] ml-2.5 ">Saved Interactions</span>
                        </div>
                    </div>
                    <div className="px-3">
                        <div>
                            <span className="text-[#DEDEDE] text-sm">Select interactions that you’d like to add. </span>
                        </div>
                    </div>


                    <div className='max-w-md mx-auto bg-[#222324] px-3 mt-3'>
    <div className="relative flex items-center w-full h-10 rounded focus-within:shadow-lg  overflow-hidden bg-[#222324]">
        <div className="grid place-items-center h-full w-12 text-gray-300 ">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
        </div>

        <input
        className="peer h-full w-full outline-none text-sm text-gray-700 pr-2 bg-[#222324]"
        type="text"
        id="search"
        placeholder="Search something.." /> 
    </div>
</div>

                    <div className=" border-b-[1px] border-[#414141] py-2 bg-[#222324] mt-0">
                        <div className="flex ml-3  pb-2 cursor-pointer"
                            onClick={toggleSheet}>
                            <span className="text-[#B59EFF] text-base mr-2">All Interactions</span>
                            <AiOutlineCaretDown color="B59EFF" size={20} cursor="pointer" style={{ marginTop: 3 }} />
                        </div>

                       

                       

                       
                       
                        
                       

                      

                    
                        
                        
                      


                    </div>

                    {tempArray.map((data:any,index:any)=>{
                        return(
                    <div className="mt-2">
                    <div className="h-[48px] w-full bg-[#000000] flex items-center pl-3">
                        <img src={data.typeImage} className="h-[20px] w-[20px] mr-3"></img>
                        <span className="text-[#B59EFF] text-lg">{data.type}</span>
                    </div>
                    <div className="flex pt-5 pb-5 pl-2 pr-2 bg-[#ffffff]  items-center relative">
                        <BiSolidCheckCircle size={22} color="#6236FF" style={{marginLeft:8}}></BiSolidCheckCircle>
                        <div className="mr-5 ml-5 rounded-md flex-col h-[68px] w-[68px] relative">
                        <img src={index==0?Google:'https://www.kasandbox.org/programming-images/avatars/marcimus-orange.png'} alt="Icon" height={68} width={68}/>
                        {index==1&&<div className=" flex h-[20px] w-full rounded-b-lg bg-[#B59EFF] text-white justify-center absolute bottom-0">Buy</div>}
                        </div>
                        <div className="flex-col">
                            <div className="text-[#000000] text-[16px] font-[500]">{data.name}</div>
                            <div className="text-[#000000] text-[12px] font-[400]">{data.data}</div>
                        </div>
                        {index==0&&<div className="absolute top-2 right-3">
                        <span className="text-[#6236FF] text-lg ">Edit</span>
                        </div>}
                        </div>
                        </div>
                        )
                        })}
                </div>
                
                <div className="flex w-full items-center justify-center px-14 mb-5 absolute bottom-[20px]">
                    <div className={`flex w-full items-center justify-center border-[1px] border-[#414141] ${(userLink!=''&&linkTitle!='')?'bg-[#6B3EFF]':''} rounded-full py-1`}>
                        <span className={`${(userLink!=''&&linkTitle!='')?'text-[#ffffff]':'text-[#B59EFF]'} text-lg font-semibold `}>Add</span>
                    </div>
                </div>




            </div>
            <div className={`absolute w-full  ${isOpen ? 'pointer-events-auto' : 'pointer-events-none'} h-[91%] bottom-0  overflow-y-auto containerbottomSheet`}>
                <CustomBottomSheet isOpen={isOpen} toggleSheet={toggleSheet}
                    selectedType={(data: any) => { setSelectedLinkOption(data) }}
                    selectedName={(name: any) => { setSelectedLinkName(name) }}
                    selectedIconName={(icName: any) => { setSelectedIcon(icName) }} />
            </div>
        </div>
    );
};

export default InteractionsSaved;